<template>
<div>
    <router-view></router-view>
    <notifications group="ops" position="bottom right" width="500" />
    <notifications group="notifications" position="top right" />
    <notifications group="auth" position="top center" />
    
    <!-- PWA Install Prompt -->
    <PwaInstallPrompt />
    
    <!-- Offline Indicator -->
    <transition name="slide-down">
      <div v-if="!isOnline" class="offline-banner">
        <fa-icon :icon="['fas', 'wifi']" class="offline-icon" />
        <span>You are offline. Some features may be limited.</span>
      </div>
    </transition>
</div>
</template>

<script>
import { RepositoryFactory } from '@/services/repositories/PublisherAPI/RepositoryFactory'
const WhitelistRepo = RepositoryFactory.get('whitelist')
import PwaInstallPrompt from '@/components/core/PwaInstallPrompt'

export default {  
  name: "App",
  components: {
    PwaInstallPrompt
  },
  mounted() {
    this.$feather.replace({
        'stroke-width': 1.5
    })
    this.Whitelist()
    
    // Initialize SSE notifications if user is authenticated
    if (this.$store.getters.isAuthenticated) {
      this.$store.dispatch('Notifications/initSSEConnection')
      this.$store.dispatch('Notifications/fetchNotifications')
      this.$store.dispatch('Notifications/requestNotificationPermission')
    }
  },
  beforeDestroy() {
    // Disconnect SSE when app is destroyed
    this.$store.dispatch('Notifications/disconnectSSE')
  },
  methods: {
    Whitelist: function() {
      var data = {
        domain: window.location.origin
      }
      WhitelistRepo.verify(data).then(result => {
        this.$store.commit('whitelist', result.data)
        this.$store.commit('response', true)
      }).catch(err => {
        this.$store.commit('response', false)
      })
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    isOnline() {
      return this.$store.getters.isOnline;
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
}
</script>
<style lang="scss">
.vue-notification {
  padding: 20px;
  margin: 0 10px 10px;
  font-size: 18px;

  background-color: #fff;
  background-clip: border-box;
  border: 0 solid rgba(0,0,0,.125);

  box-shadow: 0 0 1px rgba(0,0,0,.125), 0 1px 3px rgba(0,0,0,.2);
  margin-bottom: 1rem;

  &.warn {
    background: #FFCE54;
    border-left-color: #f48a06;
  }

  &.error {
    background: #FC6E51;
    border-left-color: #B82E24;
  }

  &.success {
    background: #A0D468;
    border-left-color: #42A85F;
  }
}

.offline-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #f59e0b;
  color: white;
  padding: 12px;
  text-align: center;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 500;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.offline-icon {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.slide-down-enter-active {
  transition: all 0.3s ease;
}

.slide-down-leave-active {
  transition: all 0.2s ease;
}

.slide-down-enter {
  transform: translateY(-100%);
  opacity: 0;
}

.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
<style>
input[id="username"] {
    text-transform: lowercase;
}
</style>